import { useMutation } from '@tanstack/react-query';
import { submitRecovery, type RecoveryFormValues, type RecoveryResponse } from '../api/auth.api';

/**
 * Hook for handling password recovery (password reset)
 * Uses React Query mutation for recovery submission
 * Does not update auth store as this is a pre-auth flow
 */
export function useRecovery() {
  return useMutation({
    mutationFn: ({ flowId, values }: { flowId: string; values: RecoveryFormValues }) =>
      submitRecovery(flowId, values),
    onSuccess: (data: RecoveryResponse) => {
      // Recovery email sent successfully
      // The UI should show a success message
      console.log('Recovery email sent:', data.state);
    },
    onError: (error) => {
      // Error handling is done in the component
      console.error('Recovery error:', error);
    },
  });
}
